import React, { useCallback, useEffect, useState } from "react";
import { ApiGet } from "../../../helper/axiosFunctions";
import { commonToast } from "../../../helper/Toast";
import { formatDate } from "../../../helper/commonFunctions";
import { useTranslation } from "react-i18next";

export default function WorkshopDetailSettings({ deckDetails }) {
    const { t, i18n } = useTranslation();
    const [creatorData, setCreatorData] = useState({});
    const [loading, setLoading] = useState(false);

    const getCreatorData = useCallback(async () => {
        if (!deckDetails?.authorId) return;
        setLoading(true);
        try {
            const response = await ApiGet(`/users/${deckDetails.authorId}`);
            setCreatorData(response?.data);
        } catch (error) {
            commonToast(error?.data?.error || error?.message, "error");
        } finally {
            setLoading(false);
        }
    }, [deckDetails?.authorId]);

    useEffect(() => {
        getCreatorData();
    }, [getCreatorData]);

    const formatStatus = (status) => {
        if (status === "PUBLISHED" && i18n.language === "lt") return "PUBLIKUOTA";
        return status;
    };

    const authorName = `${creatorData?.firstName || ""} ${creatorData?.lastName || ""}`.trim();

    const rows = [
        { label: t("deckName") || "Deck Name", value: deckDetails?.deckName },
        {
            label: t("status") || "Status",
            value: deckDetails?.status ? formatStatus(deckDetails.status) : null,
        },
        { label: t("authorName") || "Author Name", value: authorName || null },
        { label: t("createdBy") || "Created By", value: authorName || null },
        {
            label: t("language") || "Language",
            value: deckDetails?.language || null,
        },
        {
            label: t("countries") || "Countries",
            value: deckDetails?.countries?.join(", ") || null,
        },
        {
            label: t("creationDate") || "Creation Date",
            value: deckDetails?.creationDate
                ? formatDate(deckDetails.creationDate)
                : null,
        },
    ].filter((r) => r.value);

    return (
        <div className="max-w-xl rounded-2xl border border-gray-200 bg-white p-4">
            <h2 className="mb-3 text-base font-bold text-gray-900">{t("Settings")}</h2>
            <div className="space-y-2.5">
                {rows.map((row) => (
                    <div
                        key={row.label}
                        className="flex items-start justify-between gap-4 border-b border-gray-50 pb-2.5 last:border-0 last:pb-0"
                    >
                        <span className="text-sm text-lightgray">{row.label}</span>
                        <span className="text-right text-sm font-medium text-gray-900">
                            {loading &&
                            (row.label === (t("authorName") || "Author Name") ||
                                row.label === (t("createdBy") || "Created By")) ? (
                                <span className="inline-block h-4 w-24 animate-pulse rounded bg-gray-100" />
                            ) : (
                                row.value
                            )}
                        </span>
                    </div>
                ))}
            </div>
            {deckDetails?.longDescription ? (
                <p className="mt-3 border-t border-gray-100 pt-3 text-sm leading-relaxed text-gray-700">
                    {deckDetails.longDescription}
                </p>
            ) : null}
        </div>
    );
}
